export default __webpack_public_path__ + "static/media/gallery_14.c963e776.jpg";